import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  TransactionsResponse,
  TransactionsRequest,
} from '@coin-depo-types';

import { GetTransactionsParams, TransactionsFacade } from '@coin-depo-core/transactions'
import { ApiService } from '@coin-depo/http';
import { AUTH_SERVICE_TOKEN, AuthFacade } from '@coin-depo-core/auth';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService implements TransactionsFacade {
  canCancelTransaction = true;

  constructor(
    private apiService: ApiService,
    @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
  ) {}

  getTransactions(params: GetTransactionsParams): Observable<TransactionsResponse> {
    const {
      filter = {},
      page = 1,
      per_page = 10,
      desc = 0,
      lang = 'en',
      trx_user_id,
    } = params;

    const data: TransactionsRequest = {
      client_token: this.auth.accessToken,
      username: this.auth.userData.username,
      tz_offset: 0,
      lang,
      desc,
      page,
      per_page,
      ...(trx_user_id ? { trx_user_id } : {}),
      ...filter,
    };

    return this.apiService.getTransactionsList(data);
  }

  getTransactionsCsvList(params: GetTransactionsParams): Observable<Blob> {
    const {
      filter = {},
      page = 1,
      per_page = 10,
      desc = 0,
      lang = 'en',
    } = params;

    const data = {
      client_token: this.auth.accessToken,
      username: this.auth.userData.username,
      tz_offset: 0,
      page,
      per_page,
      desc,
      lang,
      ...filter,
      csv: 1,
    };

    return this.apiService.getTransactionsCsvList(data);
  }

  cancelTransaction(trxid: string) {
    const data: any = {
      client_token: this.auth.accessToken,
      username: this.auth.userData.username,
      trxid,
    };
    return this.apiService.cancelWithdrawal(data);
  }
}
